import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  ExtendSessionDto,
  PublicSession,
  SessionConflictError,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const extendSession = async ({
  sessionId,
  payload,
}: {
  sessionId: string;
  payload: ExtendSessionDto;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `sessions/${sessionId}/in-call/extend-session`,
    payload,
  );
  return response.data;
};

function useExtendSession(
  mutationOptions?: UseMutationOptions<
    PublicSession,
    HttpError | SessionConflictError,
    { sessionId: string; payload: ExtendSessionDto }
  >,
) {
  return useMutation({
    mutationFn: extendSession,
    ...mutationOptions,
  });
}

export { useExtendSession };
